const validate = values => {
  const errors = {}

  // Email
  if (!values.email) {
    errors.email = 'Required'
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
    errors.email = 'Invalid email address'
  }
  // Password
  if (!values.password) {
    errors.password = 'Required'
  }
  else if (!/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/i.test(values.password)) {
    errors.password = 'Password must contain one letter, one number, one special character, and be at least 8 characters long'
  }
  // Confirm password
  if (!values.confirm) {
    errors.confirm = 'Required'
  } else if (values.password !== values.confirm) {
    errors.confirm = 'Must be the same as Password'
  }
  return errors
}

export default validate;



// WEBPACK FOOTER //
// ./src/components/common/validate.js